









































































import Vue from "vue";
import { cartModule, pricesModule } from "@/plugins/store-accessors";

export default Vue.extend({
  name: "OrderInfo",
  props: {
    name: { type: String, default: "" },
    products: { type: Array, default: () => [] },
    quantity: { type: Number, default: 0 },
    sum: { type: Number, default: 0 },
  },
  computed: {
    purchaseSum() {
      return cartModule.getPurchaseTotalSum;
    },
    benefitSum() {
      return cartModule.getBenefitTotalSum;
    },
    hidePrice() {
      return pricesModule.getHidePrice;
    },
  },
});
